import { render, staticRenderFns } from "./dept-info.vue?vue&type=template&id=0a12711e&"
import script from "./dept-info.vue?vue&type=script&lang=js&"
export * from "./dept-info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "dept-info.vue"
export default component.exports